import { forwardRef } from "react";
import type { ComponentPropsWithRef } from "react";
import { Hr } from "@react-email/components";
import { Section } from "@react-email/components";
import type { StyleValue } from "@/react/components/shared/BuilderUI/StyleValue.types";
import { useParseStyles } from "../../../Design/useParseStyles";
import { defaultStyles } from "./defaultStyles";

const baseLineStyles = {
  boxSizing: "border-box",
  margin: "0 auto",
  borderLeftWidth: "0",
  borderRightWidth: "0",
  borderBottomWidth: "0",
} as const;

export interface LineProps extends ComponentPropsWithRef<"table"> {
  styles: Record<string, StyleValue>;
}

export const Line = forwardRef<HTMLTableElement, LineProps>(
  ({ styles, ...rest }, ref) => {
    const { margin, padding, ...stylesWithoutMarginAndPadding } = styles;
    const {
      margin: defaultMargin,
      padding: defaultPadding,
      ...defaultStylesWithoutMarginAndPadding
    } = defaultStyles;
    const inlineStyles = useParseStyles({
      baseStyles: baseLineStyles,
      styles: stylesWithoutMarginAndPadding,
      defaultStyles: defaultStylesWithoutMarginAndPadding,
    });
    const sectionStyles = useParseStyles({
      styles: { margin, padding },
      defaultStyles: { margin: defaultMargin, padding: defaultPadding },
    });

    return (
      <Section ref={ref} style={sectionStyles} {...rest}>
        <Hr style={inlineStyles} />
      </Section>
    );
  },
);

Line.displayName = "Line";
